import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { Overlay } from 'react-bootstrap';
import BudgetPopover from './BudgetPopover.jsx';

class BudgetOverlay extends Component {

    static propTypes = {
        recommendedBudget: PropTypes.number
    }

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false
        };
    }

    render() {
        return (
            <span className='budget-overlay' onMouseOver={ this.onMouseOver.bind(this) } onMouseOut={ this.onMouseOut.bind(this) }  >
                <i className='fa fa-exclamation-triangle' aria-hidden='true' ref='target' onMouseOver={ this.onMouseOver.bind(this) } onMouseOut={ this.onMouseOut.bind(this) }  />
                <Overlay show={ this.state.showPopup } container={ this } { ...this.props } target={ () => findDOMNode(this.refs.target) } >
                    <BudgetPopover
                        className='budget-popover'
                        recommendedBudget={ this.props.recommendedBudget }
                        onMouseOver={ this.onMouseOver.bind(this) }
                        onMouseOut={ this.onMouseOut.bind(this) }
                    />
                </Overlay>
            </span>
        );
    }

    onMouseOver() {
        this.setState({ showPopup: true });
    }

    onMouseOut() {
        this.setState({ showPopup: false });
    }
}

export default BudgetOverlay;
